import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudHyperVisorDetailList = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'hypervisor/list_detail/',
    params: params,
    method: 'get'
  })
}
